import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { API_URL, TOKEN } from '..';

const StaffTable = ({ data, showPrivileges }) => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [privileges, setPrivileges] = useState({
        invoice: { edit: false, delete: false, read: false, changeStatus: false },
        quotes: { edit: false, delete: false, read: false, changeStatus: false }
    });

    const TOKEN = localStorage.getItem('tokenID')

    const fetchPrivileges = async (id) => {
        try {
            const response = await fetch(`${API_URL}/api/privileges/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                setPrivileges(data.privileges || {
                    invoice: { edit: false, delete: false, read: false, changeStatus: false },
                    quotes: { edit: false, delete: false, read: false, changeStatus: false }
                });
                setShowModal(true);
            } else {
                throw new Error('Failed to fetch privileges');
            }
        } catch (err) {
            console.error('Fetch privileges error:', err);
            alert('Error fetching privileges: ' + err.message);
        }
    };

    const savePrivileges = async () => {
        try {
            const response = await fetch(`${API_URL}/api/privileges/${selectedUserId}`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${TOKEN}`
                },
                body: JSON.stringify({ privileges })
            });
            if (response.status === 200) {
                setShowModal(false);
                alert('Privileges saved successfully');
            } else {
                throw new Error('Failed to save privileges');
            }
        } catch (err) {
            console.error('Save privileges error:', err);
            alert('Error saving privileges: ' + err.message);
        }
    };

    const handlePrivilegeChange = (category, privilege) => {
        setPrivileges(prev => ({
            ...prev,
            [category]: {
                ...prev[category],
                [privilege]: !prev[category][privilege]
            }
        }));
    };

    useEffect(() => {
        const table = $('#dataTable').DataTable({
            data: data,
            responsive: true,
            pageLength: 10,
            columns: [
                
                { data: 'name', title: 'Name' },
                { data: 'phone', title: 'Phone' },
                { data: 'role', title: 'Role' },
                {
                    data: null,
                    render: function (data, type, row) {
                        return `
                            <div class="dropdown">
                                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i class="ph ph-list"></i>
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View </a></li>
                                    ${showPrivileges ? `<li><a style="cursor:pointer" class="dropdown-item privilege-btn" data-id="${row.id}"><i class="ph ph-shield"></i> Privileges </a></li>` : ''}
                                </ul>
                            </div>
                        `;
                    },
                    title: 'Actions',
                    orderable: false
                }
            ]
        });

        $('#dataTable tbody').on('click', '.view-btn', function () {
            const id = $(this).data('id');
            navigate(`/staff/view/${id}`);
        });

        if (showPrivileges) {
            $('#dataTable tbody').on('click', '.privilege-btn', function () {
                const id = $(this).data('id');
                setSelectedUserId(id);
                fetchPrivileges(id);
                
            });
        }

        return () => {
            table.destroy(true);
        };
    }, [data, navigate, showPrivileges]);

    return (
        <div className="card basic-data-table">
            <div className="card-header">
                <div className="row">
                    <h5 className="card-title mb-0 col-md-6">List of {showPrivileges ? 'Users' : 'Admins'}</h5>
                </div>
            </div>
            <div className="card-body">
                <table
                    className="table bordered-table mb-0"
                    id="dataTable"
                    data-page-length={10}
                >
                    <thead>
                        <tr>
                            
                            <th scope="col">Name</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Role</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Manage Privileges</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h5>Invoice Privileges</h5>
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={privileges.invoice.edit}
                            onChange={() => handlePrivilegeChange('invoice', 'edit')}
                        />
                        <label className="form-check-label">Edit</label>
                    </div>
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={privileges.invoice.delete}
                            onChange={() => handlePrivilegeChange('invoice', 'delete')}
                        />
                        <label className="form-check-label">Delete</label>
                    </div>
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={privileges.invoice.read}
                            onChange={() => handlePrivilegeChange('invoice', 'read')}
                        />
                        <label className="form-check-label">Read</label>
                    </div>
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={privileges.invoice.changeStatus}
                            onChange={() => handlePrivilegeChange('invoice', 'changeStatus')}
                        />
                        <label className="form-check-label">Change Status</label>
                    </div>

                    <h5 className="mt-4">Quotes Privileges</h5>
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={privileges.quotes.edit}
                            onChange={() => handlePrivilegeChange('quotes', 'edit')}
                        />
                        <label className="form-check-label">Edit</label>
                    </div>
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={privileges.quotes.delete}
                            onChange={() => handlePrivilegeChange('quotes', 'delete')}
                        />
                        <label className="form-check-label">Delete</label>
                    </div>
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={privileges.quotes.read}
                            onChange={() => handlePrivilegeChange('quotes', 'read')}
                        />
                        <label className="form-check-label">Read</label>
                    </div>
                    <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={privileges.quotes.changeStatus}
                            onChange={() => handlePrivilegeChange('quotes', 'changeStatus')}
                        />
                        <label className="form-check-label">Change Status</label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={savePrivileges}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default StaffTable;